import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../partials/header/header.component';
import { FooterComponent } from '../partials/footer/footer.component';
import { BlockComponent } from '../partials/block/block.component';
import { LoadingComponent } from '../partials/loading/loading.component';
import { ReportComponent } from '../partials/report/report.component';
import { AboutUsModalComponent } from '../partials/about-us-modal/about-us-modal.component';
import { FormsModule } from '@angular/forms';


@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
  ],
  declarations: [
    HeaderComponent,
    FooterComponent,
    BlockComponent,
    LoadingComponent,
    ReportComponent,
    AboutUsModalComponent,
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    BlockComponent,
    LoadingComponent,
    ReportComponent,
    AboutUsModalComponent,
  ]
})

export class CoreModule {

}
